import React from 'react';
import BackupList from '../../components/backup/BackupList';

const BackupListPage = () => {
  return (
    <div>
      <BackupList />
    </div>
  );
};

export default BackupListPage;